// notification.service.ts
import { Injectable } from '@angular/core';
import { NgToastService } from 'ng-angular-popup';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toast: NgToastService) {}

  showSuccess(message: string) {
    this.toast.success({ detail: message, summary: 'Success', duration: 5000 });
  }

  showError(message: string) {
    this.toast.error({ detail: message, summary: 'Error', sticky: true });
  }

  showInfo(message: string) {
    this.toast.info({ detail: message, summary: 'Info', sticky: true });
  }

  showWarn(message: string) {
    this.toast.warning({ detail: message, summary: 'Warning', duration: 5000 });
  }
}
